export default __webpack_public_path__ + "static/media/Grimherald Chestguard.93872445.jpg";